import { FaRobot } from "react-icons/fa";

import { cn } from "./cn";
import { FOCUS_RING } from "./theme";

/**
 * Fixed bottom-right launcher, in the same spot as the old AISuggestionBot's button. z-index is
 * inline rather than a Tailwind arbitrary-value class (z-[...]) since this project's Tailwind v2
 * build doesn't generate those.
 */
export function AdvisorLauncherButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Open the AI offer advisor"
      style={{ zIndex: 1000 }}
      className={cn(
        "fixed bottom-6 right-6 flex h-16 w-16 items-center justify-center rounded-full bg-revampBlue text-white shadow-xl transition-colors hover:bg-revampDarkBlue",
        FOCUS_RING
      )}
    >
      <FaRobot className="h-7 w-7" />
    </button>
  );
}
